import * as api from '../_utils/api';

export class CuratorsApi {

    static async getCuratorProfile(curatorId: number): Promise<any> {
        return api._get(`curators/get/${curatorId}`);
    }
}
